import { render } from "./UpdateGame.vue?vue&type=template&id=5bc23219&scoped=true"
import script from "./UpdateGame.vue?vue&type=script&lang=js"
export * from "./UpdateGame.vue?vue&type=script&lang=js"

import "./UpdateGame.vue?vue&type=style&index=0&id=5bc23219&scoped=true&lang=css"
import "./UpdateGame.vue?vue&type=style&index=1&id=5bc23219&lang=scss"
import "./UpdateGame.vue?vue&type=style&index=2&id=5bc23219&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc23219"]])

export default __exports__